import { cond, compose } from 'ramda';
import { getNickname } from '@play/utility/player';
import { getName as getName$1 } from '@play/utility/team';

/**
 * Checks if a contestant has successfully signed up in a league when check in is enabled
 *
 * @param contestant
 */
const isSignedUp = (contestant) => contestant.state === "signed_up";
/**
 * Checks if a contestant has successfully checked in (or signed up when check in is disabled)
 *
 * @param contestant
 */
const isCheckedIn = (contestant) => contestant.state === "checked_in";
/**
 * Checks if contestant has signed up but must be first accepted by an admin
 *
 * @param contestant
 */
const isWaitingForLeagueJoin = (contestant) => contestant.state === "sign_up_pending";
/**
 * Checks if contestant is still playing
 *
 * @param contestant
 */
const isPlaying = (contestant) => contestant.state === "playing";
/**
 * Checks if contestant has finished playing
 *
 * @param contestant
 */
const isFinished = (contestant) => contestant.state === "finished";

/**
 * Checks if the contestant is a player
 *
 * @param contestant
 */
const isPlayer = (contestant) => Boolean(contestant.user);
/**
 * Checks if the contestant is a team
 *
 * @param contestant
 */
const isTeam = (contestant) => Boolean(contestant.team);

/**
 * Gets the id of the contestant
 *
 * @param contestant
 */
const getId = (contestant) => +contestant.id;
/**
 * Gets the team profile of a contestant.
 * Will return nothing if contestant is a player.
 *
 * @param contestant
 */
const getTeam = (contestant) => contestant.team;
/**
 * Gets the player profile of a contestant.
 * Will return nothing if contestant is a team.
 *
 * @param contestant
 */
const getPlayer = (contestant) => contestant.user;
/**
 * Gets the actual signed up contestant.
 *
 * @param contestant
 */
const getActualContestant = cond([[isTeam, getTeam], [isPlayer, getPlayer]]);
/**
 * Gets the name of the contestant.
 *
 * @param contestant
 */
const getName = cond([
    [
        isTeam,
        compose(getName$1, getActualContestant),
    ],
    [
        isPlayer,
        compose(getNickname, getActualContestant),
    ],
]);

// export * from "./lib/sorting";

/**
 * Generated bundle index. Do not edit.
 */

export { getActualContestant, getId, getName, getPlayer, getTeam, isCheckedIn, isFinished, isPlayer, isPlaying, isSignedUp, isTeam, isWaitingForLeagueJoin };
//# sourceMappingURL=play-utility-contestant.js.map
